import { notification } from 'ant-design-vue'
import { i18n, locale } from '@/plugins/i18n'

// Создаем глобальную очередь для сообщений из вне контекста
const notificationQueue: Array<() => void> = []

export const useAppNotification = () => {
  const show = (
    type: 'success' | 'error' | 'info' | 'warning',
    message: string,
    description?: string,
    config?: any,
  ) => {
    const defaultConfig: any = {
      message,
      description,
      placement: 'topRight',
      duration: type === 'error' ? 8 : 4.5,
      ...config,
    }

    notification[type](defaultConfig)
  }

  const enqueue = (
    type: 'success' | 'error' | 'info' | 'warning',
    message: string,
    description?: string,
  ) => {
    notificationQueue.push(() => show(type, message, description))
  }

  const processQueue = () => {
    while (notificationQueue.length > 0) {
      const notificationFn = notificationQueue.shift()
      if (notificationFn) {
        try {
          notificationFn()
        } catch (error) {
          console.error('Error showing notification:', error)
        }
      }
    }
  }

  return {
    success: (message: string, description?: string) => show('success', message, description),
    error: (message: string, description?: string) => show('error', message, description),
    info: (message: string, description?: string) => show('info', message, description),
    warning: (message: string, description?: string) => show('warning', message, description),
    enqueue,
    processQueue,
  }
}

export type NotifyParamWithT = {
  message?: string
  description?: string
  messageKey?: string
  descriptionKey?: string
}

export const globalNotification = {
  successWithT: ({ message, messageKey, description, descriptionKey }: NotifyParamWithT) => {
    const currentLocale = useStorage('locale', import.meta.env.VITE_APP_LANG)
    locale.value = currentLocale.value

    if (typeof window !== 'undefined' && notification) {
      notification.success({
        message: message ? message : messageKey ? i18n.global.t(messageKey) : '',
        description: description
          ? description
          : descriptionKey
            ? i18n.global.t(descriptionKey)
            : '',
      })
    } else {
      console.log('SUCCESS:', messageKey, descriptionKey)
    }
  },
  errorWithT: ({ message, messageKey, description, descriptionKey }: NotifyParamWithT) => {
    const currentLocale = useStorage('locale', import.meta.env.VITE_APP_LANG)
    locale.value = currentLocale.value

    if (typeof window !== 'undefined' && notification) {
      notification.error({
        message: message ? message : messageKey ? i18n.global.t(messageKey) : '',
        description: description
          ? description
          : descriptionKey
            ? i18n.global.t(descriptionKey)
            : '',
      })
    } else {
      console.error('ERROR:', messageKey, descriptionKey)
    }
  },
  success: (message: string, description?: string) => {
    if (typeof window !== 'undefined' && notification) {
      notification.success({ message, description })
    } else {
      console.log('SUCCESS:', message, description)
    }
  },
  error: (message: string, description?: string) => {
    if (typeof window !== 'undefined' && notification) {
      notification.error({ message, description })
    } else {
      console.error('ERROR:', message, description)
    }
  },
}
